module.exports = __webpack_public_path__ + "img/history.880ac8f6.png";